import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FolderStateService {
  private currentFolderId: string | null = null;

  setCurrentFolderId(folderId: string) {
    this.currentFolderId = folderId;
  }

  clearCurrentFolderId() {
    this.currentFolderId = null;
  }

  getCurrentFolderId(): string | null {
    return this.currentFolderId;
  }
}
